export const ImportInInsert = {
  flow: 'y',
  gap: 'A',
  CaptionTitle: {
    Text: {
      text: '{{ editor.insert.import | polyglot }}'
    }
  },
  Flex: {
    gap: 'A',
    flow: 'y',
    margin: '- -Z2',
    childExtends: 'DomainItem',
    childrenAs: 'state',
    childProps: {
      Hgroup: {
        H: {
          text: (el, s) => el.call('polyglot', s.title || '')
        },
        P: {
          text: (el, s) => el.call('polyglot', s.descr || '')
        }
      },
      Icon: {
        name: '{{ icon }}'
      },
      Button: {
        margin: '-Y -Z2 - auto',
        text: '{{ publish.sync.connect | polyglot }}',
        icon: 'plus oval',
        gap: 'Y1',
        Icon: {
          order: 2,
          color: 'blue'
        },
        extends: ['CanvasButton', 'Button'],
        padding: 'Y2 Z2',
        fontSize: 'Z2',
        onClick: (ev, el, s) => s.onAdd?.(el, s)
      },
      align: 'start',
      Upgrade: null
    },
    children: [
      {
        icon: 'globe',
        title: 'editor.import.liveWebsite',
        descr: 'editor.import.liveWebsiteDescr'
      },
      {
        icon: 'figma',
        title: 'Figma',
        descr: 'publish.sync.figma.descr'
      },
      {
        icon: 'terminal',
        title: 'editor.import.localFiles',
        descr: 'editor.import.localFilesDescr'
      }
    ]
  }
}
